import { observer } from 'mobx-react';
import * as React from 'react';
import reactStringReplace from 'react-string-replace';
import { Card, FlexRow, FormCell, Grid, TextInput } from 'ui-toolkit';
import { PDFPreview } from 'ui-toolkit/components/PDFPreview';
import { IPolicyJacketUI } from '../classes/PolicyJacketUI';
import { IUnderwriterDataUI } from '../classes/UnderwriterDataUI';
import FileUploadButton from './fields/FileUploadButton/FileUploadButton';
import FileReview from './FileReview';
import OpenLinkInNewTab from './LinkInNewTab';
import UpdateMessage from './UpdateMessage';
import GrayLine from '../../components/shared/GrayLine';

interface IProps {
  title: string;
  subTitle?: string | null;
  policyJacketLabel?: string | null;
  policyJacketText: string;
  underwriter: IUnderwriterDataUI;
  policyJacket: IPolicyJacketUI;
  error: any;
  fetchedSuccess: boolean;
  policyNumberRequired: boolean;
  onDeletePolicyJacket: () => void;
  onJacketUpload: (files: FileList | null) => void;
  onPolicyChange: (newValue: string | null, error?: string | null) => void;
  onPolicyNumberBlur: () => void;
  isAmericanDigital: boolean;
}

interface IState {
  showPdfPreview: boolean;
}

class AddPolicyDetails extends React.Component<IProps, IState> {
  public readonly state: IState = {
    showPdfPreview: false,
  };

  public render() {
    return (
      <Card>
        <Grid>
          <FormCell label={this.props.subTitle}>
            <h2>{this.props.title}</h2>
          </FormCell>
          <FormCell label={this.props.policyJacketLabel}>
            <div>
              {reactStringReplace(this.props.policyJacketText, "{Underwriter's website}", (match, i) => (
                <OpenLinkInNewTab key={i} link={this.props.underwriter.websiteURL}>
                  {this.props.underwriter.name}'s website
                </OpenLinkInNewTab>
              ))}
            </div>
          </FormCell>
          {this.props.policyJacket.jacketName ? (
            <FileReview
              onDeleteClick={this.props.onDeletePolicyJacket}
              onFileNameClick={this.togglePdfPreview}
              fileName={this.props.policyJacket.jacketName}
            />
          ) : (
            <FlexRow>
              <FileUploadButton onFileUpload={this.props.onJacketUpload} />
            </FlexRow>
          )}
          {this.props.policyNumberRequired ? (
            <>
              <GrayLine />
              <Grid templateColumns={'3fr 1fr'} alignItems={'center'}>
                <TextInput
                  value={this.props.policyJacket.policyNumber}
                  readOnly={this.props.isAmericanDigital}
                  errorText={this.props.error.policyNumber || null}
                  onChange={this.props.onPolicyChange}
                  onBlur={this.props.onPolicyNumberBlur}
                  isRequired={true}
                  label={'Policy number'}
                  placeholder={'0123456789'}
                />
                <UpdateMessage fetchedSuccess={this.props.fetchedSuccess} />
              </Grid>
            </>
          ) : (
            <UpdateMessage fetchedSuccess={this.props.fetchedSuccess} />
          )}
          {this.state.showPdfPreview && (this.props.policyJacket.file || this.props.policyJacket.latestJacketLink) ? (
            <PDFPreview
              file={
                this.props.policyJacket.latestJacketLink
                  ? this.props.policyJacket.latestJacketLink
                  : this.props.policyJacket.file
              }
              onClose={this.togglePdfPreview}
            />
          ) : null}
        </Grid>
      </Card>
    );
  }

  private togglePdfPreview = () => {
    this.setState((state) => ({
      showPdfPreview: !state.showPdfPreview,
    }));
  };
}

export default observer(AddPolicyDetails);
